import { Chips } from "../ui-kit/Chips";
import { TabContentHeader } from "../ui-kit/TabContentHeader";
import { CollapseAllIcon } from "../assets/CollapseAll";
import { TabContentBody } from "../ui-kit/TabContentBody";
import { OrderEntry } from "./OrderEntry";
import dedent from "dedent";
import { useEffect, useMemo, useState } from "react";
import { massApiUrl } from "../utils/utils";
import { GET_ORDERS } from "../queries/orders.queries";
import { useToken } from "../hooks/useToken";
import { HexString } from "@mass-money/sdk/web";

export enum OrderStatus {
  Waiting = 'waiting',
  Invalid = 'invalid',
  Completed = 'completed',
  SimulationFailed = 'simulationFailed',
  NotEnoughGas = 'notEnoughGas',
  Running = 'running',
  Failed = 'failed',
  Succeeded = 'succeeded',
  Cancelled = 'cancelled',
}

export type Order = {
  code: string;
  status: OrderStatus;
  id: HexString;
  creationDate: string;
}

export function Orders() {
  const { token } = useToken();
  const [orders, setOrders] = useState<Order[]>([]);

  useEffect(() => {
    async function _fetch() {
      const result = await fetch(`${massApiUrl}/graphql`, {
        method: "POST",
        headers: {
          "content-type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          query: GET_ORDERS,
        })
      }).then(res => res.json());

      setOrders(result.data.pendingSchedulerTasks);
    }

    _fetch();
  }, [token]);

  const statuses = useMemo(
    () => Object.values(OrderStatus) as OrderStatus[],
    []
  )

  const grouped = useMemo(() => {
    return orders.reduce<Record<OrderStatus, Order[]>>((acc, op) => {
      const key = op.status as OrderStatus;
      if (!acc[key]) acc[key] = [];
      acc[key].push(op);
      return acc;
    }, {} as Record<OrderStatus, Order[]>)
  }, [orders])

  return (
    <>
      <TabContentHeader>
        <div className="flex justify-between w-full items-start self-stretch">
          <Chips label="All states" />
          <Chips isActive={false} leading={<CollapseAllIcon />} className="!px-2 !py-[5px]" />
        </div>
      </TabContentHeader>
      <TabContentBody>
        <div className="flex flex-col w-full">
          {statuses.map(status => {
            const ops = grouped[status] ?? []
            return ops.length > 0 ? (
              <OrderEntry
                key={status}
                status={status}
                operations={ops}
              />
            ) : null
          })}
        </div>
      </TabContentBody>
    </>
  )
}